export const categoryConst ={
    
    ADD_CATEGORY: 'ADD_CATEGORY_REQUEST',
    ADD_CATEGORY_SUCCESS: 'ADD_CATEGORY_SUCCESS',
    ADD_CATEGORY_FAILURE: 'ADD_CATEGORY_FAILURE',

    UPDATE_CATEGORY: 'UPDATE_CATEGORY_REQUEST',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

    VIEW_CATEGORY: 'VIEW_CATEGORY_REQUEST',
    VIEW_CATEGORY_SUCCESS: 'VIEW_CATEGORY_SUCCESS',
    VIEW_CATEGORY_FAILURE: 'VIEW_CATEGORY_FAILURE',

    VIEW_SUB_CATEGORY_REQUEST: 'VIEW_SUB_CATEGORY_REQUEST',
    VIEW_SUB_CATEGORY_SUCCESS: 'VIEW_SUB_CATEGORY_SUCCESS',
    VIEW_SUB_CATEGORY_FAILURE: 'VIEW_SUB_CATEGORY_FAILURE',

    VIEW_CATEGORY_DETAIL: 'VIEW_CATEGORY_DETAIL',
    VIEW_CATEGORY_DETAIL_SUCCESS: 'VIEW_CATEGORY_DETAIL_SUCCESS',
    VIEW_CATEGORY_DETAIL_FAILURE: 'VIEW_CATEGORY_DETAIL_FAILURE',

    VIEW_PARENT_CATEGORY:'VIEW_PARENT_CATEGORY',
    VIEW_PARENT_CATEGORY_SUCCESS: 'VIEW_PARENT_CATEGORY_SUCCESS',
    VIEW_PARENT_CATEGORY_FAILURE: 'VIEW_PARENT_CATEGORY_FAILURE',

    
    VIEW_ALL_CATEGORY_REQUEST: 'VIEW_ALL_CATEGORY_REQUEST',
    VIEW_ALL_CATEGORY_SUCCESS: 'VIEW_ALL_CATEGORY_SUCCESS',
    VIEW_ALL_CATEGORY_FAILURE: 'VIEW_ALL_CATEGORY_FAILURE',

    STATUS_CATEGORY: 'STATUS_CATEGORY_REQUEST',
    STATUS_CATEGORY_SUCCESS: 'STATUS_CATEGORY_SUCCESS',
    STATUS_CATEGORY_FAILURE: 'STATUS_CATEGORY_FAILURE',

    DELETE_CATEGORY: 'DELETE_CATEGORY_REQUEST',
    DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
    DELETE_CATEGORY_FAILURE: 'DELETE_CATEGORY_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/categoryConst.js